import _ from 'lodash';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { filterAsyncRoutesByScopes, filterAsyncRoutesByModules } from '@main/utils/resolvers';
import { getProtectedRoutes, getPublicRoutes, mergeRoutes } from 'app/store/routes/utils';

const defaultBuildOptions = () => ({ filterByModules: false, filterByScopes: true });
const defaultClearOptions = () => ({ filterByModules: false });

export const buildAsyncRoutes = createAsyncThunk(
  'routes/buildAsyncFromScopes',
  async (entryOptions, { getState, rejectWithValue }) => {
    const options = _.merge({}, defaultBuildOptions(), entryOptions);
    try {
      const { profile, config } = getState();

      const scopes = profile?.scopes ?? [];
      const company = config?.config?.company ?? {};

      const errors = [];

      if (!Array.isArray(scopes)) {
        errors.push('Scopes must be an array');
      }

      if (errors.length) {
        return rejectWithValue(errors);
      }

      const publicRoutes = _.clone(getPublicRoutes());

      const protectedRoutes = _.clone(getProtectedRoutes());
      let filteredProtectedRoutes = protectedRoutes;

      if (options.filterByModules === true) {
        const moduleKeys = company?.moduleKeys;
        filteredProtectedRoutes = filterAsyncRoutesByModules(protectedRoutes, moduleKeys);
      }

      const filtered = filterAsyncRoutesByScopes(filteredProtectedRoutes, scopes);
      const preSelected = options.filterByScopes ? filtered : filteredProtectedRoutes;

      const selected = mergeRoutes(preSelected, publicRoutes);

      return { remaining: protectedRoutes, filtered, selected };
    } catch (error) {
      return rejectWithValue([error?.message || 'Failed to build async routes']);
    }
  }
);

export const clearAsyncRoutes = createAsyncThunk(
  'routes/cleanAsyncFromScopes',
  async (entryOptions, { getState, rejectWithValue }) => {
    const options = _.merge({}, defaultClearOptions(), entryOptions);
    try {
      const { config } = getState();
      const company = config?.config?.company ?? {};

      const publicRoutes = _.clone(getPublicRoutes());

      if (!options.filterByModules) return { selected: publicRoutes };

      const moduleKeys = company?.moduleKeys;

      const filteredPublicRoutes = filterAsyncRoutesByModules(publicRoutes, moduleKeys);

      return { selected: filteredPublicRoutes };
    } catch (error) {
      return rejectWithValue([error?.message || 'Failed to build async routes']);
    }
  }
);
